<template>
    <div style="padding-top: 90px;">
  
      <div class="size-body" v-loading="loading" element-loading-background="rgba(17, 17, 17, 0.8)">

        <div>
          <div class="title-s">
            "{{ keys }}" 검색결과
          </div>
  
          <el-row :span="24" :gutter="0" style="padding: 10px;min-height: 200px;" class="row-bg">
            <el-col :xs="12" :sm="6" :lg="3" class="card" style="position: relative;" v-for="(item,index) in PageData.List" :key="index" >
              
                <!-- <span v-if="item.ending==0" class="ending">완결</span>
                <span v-else class="ending">제 {{ item.ending }} 화</span> -->
                <span v-if="item.today==1" class="ending">Today</span>
                
                <router-link :to="'/Detail?id='+item.id">

                  <el-card shadow="hover" :body-style="{ padding: '0px', width: '100%' }"
                      style="margin: 3px 3px;border: 0;border-radius: 5px;background-color: #000;">
                      <span>
                      <el-image style="width: 100%; aspect-ratio: 9/13;border-radius: 5px 5px 0 0;text-align: center;" :src="item.image" fit="cover">
                          <div slot="error">
                          <img src="@/assets/no_img.png" style="width: 100%; aspect-ratio: 9/13;text-align: center;"
                              fit="cover">
                          </div>
                          <div slot="placeholder">
                          <img src="@/assets/loading.gif" style="width: 100%; aspect-ratio: 9/13;text-align: center;"
                              fit="cover">
                          </div>
                      </el-image>
                      </span>
                      

                      <div style="margin: 0 8px;padding: 3px 0;min-height: 40px;">
                      <el-tooltip transition="" effect="dark" :content="item.intor" placement="top">
                          <div class="one_line" style="color: #ddd;font-size: 0.9rem;width:100%;text-align: left;">
                          <div>{{ item.title }}</div>
                          <div>
                            <!-- {{ item.star }} -->
                            <span v-if="item.ending==0">완결</span>
                            <span v-else>제 {{ item.ending }} 화</span>
                          </div>
                          </div>
                      </el-tooltip>
                      </div>

                  </el-card>

                </router-link>
  
            </el-col>
          </el-row>
        </div>


        <div style="margin: 50px 0;text-align: center;">

            <el-pagination
                background
                layout="prev,pager, next" 
                @prev-click="prevPage"
                @next-click="nextPage"
                @current-change="currentChange"
                :pager-count="5"
                :page-size="32"
                :current-page="type.page"
                :total="PageData.Total">
            </el-pagination>

        </div>


        <div>
          <!-- 推荐视频 -->
          <div class="title-s">
            연관영상
          </div>

          <el-row :span="24" :gutter="0" style="padding: 10px;min-height: 200px;" class="row-bg">
            <el-col :xs="8" :sm="6" :lg="3" class="card" style="position: relative;" v-for="(item,index) in PageData.top" :key="index" >
              
              <!-- <span v-if="item.ending==0" class="ending">완결</span>
              <span v-else class="ending">제 {{ item.ending }} 화</span> -->
              <span v-if="item.today==1" class="ending">Today</span>
              
              <router-link :to="'/Detail?id='+item.id">

                <el-card shadow="hover" :body-style="{ padding: '0px', width: '100%' }"
                    style="margin: 3px 3px;border: 0;border-radius: 5px;background-color: #000;">
                    <span>
                    <el-image style="width: 100%; aspect-ratio: 9/13;border-radius: 5px 5px 0 0;text-align: center;" :src="item.image" fit="cover">
                        <div slot="error">
                        <img src="@/assets/no_img.png" style="width: 100%; aspect-ratio: 9/13;text-align: center;"
                            fit="cover">
                        </div>
                        <div slot="placeholder">
                        <img src="@/assets/loading.gif" style="width: 100%; aspect-ratio: 9/13;text-align: center;"
                            fit="cover">
                        </div>
                    </el-image>
                    </span>
                    

                    <div style="margin: 0 8px;padding: 3px 0;min-height: 40px;">
                    <el-tooltip transition="" effect="dark" :content="item.intor" placement="top">
                        <div class="one_line" style="color: #ddd;font-size: 0.9rem;width:100%;text-align: left;">
                        <div>{{ item.title }}</div>
                        <div>
                          <!-- {{ item.star }} -->
                          <span v-if="item.ending==0">완결</span>
                          <span v-else>제 {{ item.ending }} 화</span>
                        </div>
                        </div>
                    </el-tooltip>
                    </div>

                </el-card>

              </router-link>

            </el-col>
          </el-row>
        </div>
  

      </div>
      
    </div>
  </template>
  
  <script>
  export default {
    name: 'TypeView',
    components: {
  
    },
    data(){
      return{
        loading:true,
        nodata:false,
        // typeList:[],
        keys:'',
        PageData:{
          pageTotal:0,
          Total:0,
          indexadlist:[],
          adlist:[],
          List:[],
          top:[]
        },
        type:{
          type0:0,
          type1:0,
          type2:0,
          type3:0,
          type4:0,
          order:0,
          page:1,
        },
      }
    },
    created() {
      
      this.type.page = this.$route.query.page==undefined?1:parseInt(this.$route.query.page)
      this.type.type0 = this.$route.query.type==undefined?0:this.$route.query.type
      this.type.type1 = this.$route.query.type1==undefined?0:this.$route.query.type1
      this.type.type2 = this.$route.query.type2==undefined?0:this.$route.query.type2
      this.type.type3 = this.$route.query.type3==undefined?0:this.$route.query.type3
      this.type.type4 = this.$route.query.type4==undefined?0:this.$route.query.type4

      this.keys = this.$route.query.keys
    },
    mounted() {
      
      this.type.page = this.$route.query.page==undefined?1:parseInt(this.$route.query.page)
      this.type.type0 = this.$route.query.type==undefined?0:this.$route.query.type
      this.type.type1 = this.$route.query.type1==undefined?0:this.$route.query.type1
      this.type.type2 = this.$route.query.type2==undefined?0:this.$route.query.type2
      this.type.type3 = this.$route.query.type3==undefined?0:this.$route.query.type3
      this.type.type4 = this.$route.query.type4==undefined?0:this.$route.query.type4

      this.keys = this.$route.query.keys

      this.loadPage()

    },
    watch: {
      // 监听路由对象 $route 的变化
      '$route': {
        handler: function (to, from) {
          // 路由变化时执行的操作
          this.loading = true
          this.type.page = this.$route.query.page==undefined?1:parseInt(this.$route.query.page)
          this.type.type0 = this.$route.query.type==undefined?0:this.$route.query.type
          this.type.type1 = this.$route.query.type1==undefined?0:this.$route.query.type1
          this.type.type2 = this.$route.query.type2==undefined?0:this.$route.query.type2
          this.type.type3 = this.$route.query.type3==undefined?0:this.$route.query.type3
          this.type.type4 = this.$route.query.type4==undefined?0:this.$route.query.type4

          this.keys = this.$route.query.keys

          if(this.type_temp_type0 !== this.type.type0){
            this.type_temp_type0 = this.type.type0
            this.type.page = 1
          }

          var element = document.getElementById('app');
          element.scrollIntoView({ behavior: "smooth" });
          

          // this.loadType()
          this.loadPage()
        },
        // 设置为深度监听
        deep: true
      }
    },
    methods: {
      loadPage(){
        var this_ = this

        this_.PageData.List = []

        this.httpinfo.GetInfo(this,this.baseURL + "search?mark="+this.baseMark+"&keys="+this_.keys+"&type0="+this_.type.type0+"&type1="+this_.type.type1+"&type2="+this_.type.type2+"&type3="+this_.type.type3+"&type4="+this_.type.type4+"&limit=24&page="+this_.type.page, function(e) {
          if(e.data.code==0){

            this_.PageData.pageTotal = e.data.pagecount
            this_.PageData.Total = e.data.count

            this_.PageData.top = e.data.data.top

            this_.PageData.adlist = e.data.data.adlist
            
            this_.PageData.adlist.sort(() => Math.random() - 0.5) //随机位置
            this_.PageData.indexadlist = e.data.data.indexadlist
            this_.PageData.indexadlist.sort(() => Math.random() - 0.5) //随机位置


            let Temp_Rand_Arr = [],Temp_No_Rand_Arr = []
            this_.PageData.adlist.forEach(function(item){
              if(item.rand=='0'){
                Temp_Rand_Arr.push(item)
              }else{
                Temp_No_Rand_Arr.push(item)
              }
            })
            Temp_Rand_Arr.sort(() => Math.random() - 0.5) //随机位置
            this_.PageData.adlist = Temp_No_Rand_Arr.concat(Temp_Rand_Arr) //合并数组

            Temp_Rand_Arr = [],Temp_No_Rand_Arr = []
            this_.PageData.indexadlist.forEach(function(item){
              if(item.rand=='0'){
                Temp_Rand_Arr.push(item)
              }else{
                Temp_No_Rand_Arr.push(item)
              }
            })
            Temp_Rand_Arr.sort(() => Math.random() - 0.5) //随机位置
            // this_.PageData.indexadlist = Temp_No_Rand_Arr.concat(Temp_Rand_Arr) //合并数组

            Temp_No_Rand_Arr.forEach(function(item){
              Temp_Rand_Arr.splice(item.location_num-1,0,item)
            })
            this_.PageData.indexadlist = Temp_Rand_Arr


            e.data.data.list.forEach(element => {
              this_.PageData.List.push(element)
            });

          }else{
            
            this_.$message.error(e.data.msg)

          }
          this_.loading = false

          if(this_.PageData.List.length<=0){
            this_.nodata = true
          }else{
            this_.nodata = false
          }

        });
      },
      prevPage(e){
        // console.log(e)
      },
      nextPage(e){
        // console.log(e)
      },
      currentChange(e){
        // this.type.page = e
        // this.loadPage()

        this.type.page = e
        this.goTo('/Search?keys='+this.keys+'&type0='+this.type.type0+'&type1='+this.type.type1+'&type2='+this.type.type2+'&type3='+this.type.type3+'&type4='+this.type.type4+'&limit=30&page='+this.type.page)
      },
      goTo(path) {
        if (path !== this.$router.currentRoute.fullPath) {
          // console.log(path)
          this.loading = true
          this.$router.push(path);
        }
      },
    }
  }
  </script>
  <style>
  
  </style>
  